import { useRouteMatch } from "react-router-dom";

const useUrlHash = () => {
  const { params } = useRouteMatch();
  return params.hash;
};

export default useUrlHash;
